import {Screens} from '../../../../shared/routing';

export const skbInitialData = {
  services: {
    [Screens.TransportService]: {
      cardTitle: 'Транспортное приложение',
      cardBody: 'ЕСК может использоваться как электронный проездной билет в ряде городов Свердловской области',

      financial: {
        descriptionDesktop: `Единая социальная карта позволяет оплачивать проезд в общественном транспорте максимально удобно и быстро - в одно касание.`,
        descriptionMobile: 'ЕСК позволяет отказаться от наличных средств в общественном транспорте',
        featureListMarkdown: `* Транспортное приложение работает в Екатеринбурге, В. Пышме, Первоуральске, Ревде, Сысерти, пгт. Шаля.
* Единая социальная карта, выпускаемая СКБ-банком, заменяет проездной билет с тарифом «Электронный кошелек».
* Для держателей карт с логотипом «ЕСК» и «СКБ-банк» оплата за поездку списывается с банковского счета карты. Обязательно поддержание остатка 150 рублей.
* Для держателей карт с логотипом «Уралочка» и «Синара Банк» оплата за поездку списываться с баланса транспортного приложения. Поддержание остатка на счете 150 рублей не требуется.
* ЕСК позволит сэкономить на проезде: стоимость поездки в наземном транспорте Екатеринбурга составляет 26 рублей.`,
      },

      nonFinancial: {
        eCardReplenishmentTipsHtml:
          '<div class="text-normal">Пополнить ЕСК можно онлайн с карты любого банка. Для этого необходимо воспользоваться<a class="text-normal" href="http://www.ekarta-ek.ru/informatsiya/servis/"> сервисом</a> отложенной покупки через сайт «Фрисби». Подробнее о правилах пополнения можно узнать на<a class="text-normal" href="http://www.ekarta-ek.ru/informatsiya/voprosy-i-otvety/vidy-popolneniya/sposoby-popolneniya-ekarty/#2"> сайте</a>.</div>',
        eCardFeaturesHtml: [
          '<div class="text-medium-size">Транспортное приложение работает в Екатеринбурге, В. Пышме, Первоуральске, Ревде, Сысерти, пгт. Шаля.</div>',
          '<div class="text-medium-size">Экономия при оплате проезда в транспорте Екатеринбурга составляет 2,4 и более рублей в зависимости от выбранного общегражданского<a href="http://www.ekarta-ek.ru/obshchie-razdely/tarify/" class="text-medium-size"> тарифа</a>.</div>',
          '<div class="text-medium-size">С помощью Единой социальной карты держатели могут произвести расчет в паркоматах Екатеринбурга.</div>',
          '<div class="text-medium-size">Проезд в электропоездах Свердловской пригородной компании также может быть оплачен с помощью транспортного приложения ЕСК.</div',
        ],
        eCardFeaturesMarkDown:
          '* Транспортное приложение работает в Екатеринбурге, Березовском, Верхней Пышме, Ревде, Сысерти, Нижнем Тагиле, Первоуральске, Краснотурьинске, Среднеуральске и пгт. Шаля\n* Экономия при оплате проезда в транспорте Екатеринбурга составляет 2, 4 и более рублей в зависимости от выбранного общегражданского [тарифа](http://www.ekarta-ek.ru/obshchie-razdely/tarify/)\n* С помощью Единой социальной карты держатели могут произвести расчет в паркоматах Екатеринбурга\n* Проезд в электропоездах Свердловской пригородной компании также может быть оплачен с помощью транспортного приложения ЕСК',
        eCardReplenishmentLink: 'https://frisbi24.ru/services/pay/5178-udobnyy-marshrut',
        eCardSupportPhone: '83432702258',
        descriptionDesktop:
          'Единая социальная карта позволяет оплачивать проезд в общественном транспорте максимально удобно и быстро - в одно касание.',
        descriptionMobile:
          'С более подробной информацией о транспортном приложении Вы можете ознакомиться в разделе Поддержка.',
      },
    },
    [Screens.BankingService]: {
      cardTitle: 'Банковские сервисы',
      cardBody: 'Финансовая ЕСК является полноценной банковской картой с дополнительными сервисам',
      descriptionMarkdown: `Единая социальная карта с расчетным приложением выпускается на базе национальной платежной системы «Мир» и является полноценной банковской картой с дополнительными сервисами. Держатель ЕСК может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат.
&nbsp;
Для держателей Единой социальной карты актуальны те же правила безопасности, что и для держателей обычных банковских карт. При утере или краже карты необходимо незамедлительно обратиться в банк для блокировки, после чего карту можно будет перевыпустить. Держателям нефинансовых карт следует обращаться к оператору Единой социальной карты
&nbsp;
* Оплачивайте товары и услуги
* Получайте на карту социальные выплаты и денежные переводы
* Получайте кэшбек и спецпредложения от платежной системы «Мир»
* Всегда будьте в курсе своих финансовых операций`,
      bankPhone: '',
      bankWebsite: '',
      bankEntryLink: '',
      logoUrl: '',
    },
    [Screens.PrivilegesService]: {
      cardTitle: 'Мои льготы',
      cardBody: 'Получайте выплаты на ЕСК и будьте всегда в курсе предоставленных Вам льгот',
      descriptionMarkdown: `На банковскую Единую социальную карту можно перечислять пенсии, пособия, стипендии и другие социальные выплаты. При этом вы всегда будете в курсе назначенных Вам льгот. Оформить/перенести свои выплаты на ЕСК можно, предоставив реквизиты расчетного счета карты в орган, осуществляющий ту или иную выплату.

**Важно**: с 1 октября 2020 года переход на национальную платежную систему "Мир", на базе которой выпускается Единая социальная карта, будет обязательным для получения на карту всех социальных выплат, осуществляемых через ПФР. На карты других платежных систем средства перечисляться не будут.`,
    },
    [Screens.LoyaltyProgram]: {
      cardTitle: 'Скидки и бонусы',
      cardBody: 'Позволяет получать скидки, бонусы и специальные предложения',
      descriptionMarkdown: `Это самый простой, распространенный, старомодный и эффективный вид программ лояльности. Дисконтные программы могут быть простыми или накопительными. Как правило, дисконтная программа помогает клиенту определиться с местом покупки, при условии, что решение о покупке уже было принято.
&nbsp;
**Вы получите**
* Дисконтные программы
* Накопительная система
* Скидки у партнеров
* Оплата баллами`,
    },
    [Screens.VolunteersService]: {
      cardTitle: 'Волонтерство',
      cardBody: 'Будь в центре самых добрых событий',
      descriptionMarkdown: 'Описание секции волонтеров',
      scoresExchangeRulesURL: 'https://eskso.ru/uploads/kL/kJ/eoj-cFJeEsk7mTXwpB5n_nGstdBo.pdf',
    },
    [Screens.RewardShop]: {
      cardTitle: 'Магазин Поощрений',
      cardBody: 'Обменяйте Ваши баллы, полученные в разделе волонтерство, на товары от партнеров!',
      descriptionMarkdown:
        'Единая социальная карта дает возможность держателям получать поощрения от партнеров проекта за участие в мероприятиях волонтерами, голосование по проводимым опросам, участие в мероприятиях здорового образа жизни.\n\nПри этом вы всегда будете в курсе всех начислений и списаний баллов, наличием товаров  в пунктах выдачи и «стоимостью» обмена на баллы, истории операций.\n\nСо списком партнеров и поощрений в «Витрине» можете ознакомится по ссылке ниже. Информация доступна держателю в личном кабинете.\n\n* Регистрируйтесь на платформе «Добро.ру» и включайтесь в добрые дела\n* Участвуете в голосованиях и опросах\n* Ведите здоровый образ жизни\n* Дружите со спортом\n',
    },
    [Screens.Cashback]: {
      cardTitle: 'Регистрация в акциях Программы лояльности АО “НСПК”',
      cardBody: 'Получайте кешбэк за оплату товаров и услуг',
      descriptionMarkdown:
        'Для возможности получения кешбэка с использованием платформы лояльности АО «НСПК» все желающие обладатели карты «Уралочка» должны пройти регистрацию по прилагаемой процедуре. Регистрация в акции бесплатная.',
    },
    [Screens.ECertificates]: {
      cardTitle: 'Электронные сертификаты',
      cardBody: 'Один из способов получения государственной поддержки',
      descriptionMarkdown:
        'Электронный сертификат — один из способов получения государственной поддержки. Это электронная запись, которая содержит сведения о праве на самостоятельное приобретение товаров, работ или услуг и используется для их оплаты.',
    },
    [Screens.Skipass]: {
      cardTitle: 'Ски-пасс',
      cardBody: 'EСК "Уралочка" может использоваться как ски-пасс на подъемниках курорта "Гора Белая".',
      titleMarkdown:
        'EСК «Уралочка» может использоваться как ски-пасс на подъемниках [курорта «Гора Белая»](https://www.gorabelaya.ru/).',
      descriptionMarkdown:
        '«Гора Белая» предлагает идеальные условия для зимнего отдыха: современные подъемники, качественно подготовленные трассы различной сложности, профессиональные инструкторы и великолепные виды\n' +
        'Уральских гор. Здесь каждый найдет трассу по своему уровню подготовки.',
      activeFeatureDescription:
        'Ваша Единая социальная карта «Уралочка» активирована как ски-пасс и готова к использованию на всех подъемниках курорта.\n\n' +
        'Единая социальная карта Свердловской области позволяет держателям быть в курсе всех событий и специальных предложений горнолыжного курорта «Гора Белая».',
      agreementLink: '',
    },
  },

  support: {
    descriptionMobileMarkdown: `##### Уважаемые посетители сайта и держатели Единой Социальной карты!
По всем вопросам получения и использования карты обращайтесь на Горячую линию Государственной информационной системы «Единой социальной карты»
&nbsp;
По горячей линии можно узнать информацию о балансе, условиях обслуживания пластиковых карт, как оформить кредит или уточнить информацию по действующему кредиту, по другим услугам банка, адресах и режиме работы подразделений банка. Горячая линия работает круглосуточно.`,

    descriptionDesktopMarkdown: `##### Уважаемые держатели Единой социальной карты Свердловской области!
* Узнать больше о ЕСК, порядке ее обслуживания и полезных сервисах Вы можете, позвонив на Горячую линию "Единой социальной карты Свердловской области"

* Вопросы, связанные с банковским обслуживанием, Вы можете задать по телефону Горячей линии банка-соэмитента

* Задать вопрос о работе транспортного приложения, тарифах, порядке активации и пополнения электронного проездного можно, позвонив на Горячу линию ЕКАРТЫ

* По вопросам предоставления льгот и социальных выплат следует обращаться на Единый социальный телефон`,
  },

  aboutApplication:
    'Мобильное приложение "ЕСК" реализуется в рамках проекта "Единая социальная карта Свердловской области" по Указу Губернатора Свердловской области № 599-УГ от 13 ноября 2018 года в целях повышения эффективности, доступности и качества предоставления мер социальной поддержки на основе современных информационных технологий. Сегодня ЕСК – это многофункциональная пластиковая карта с электронным носителем, которая служит уникальным ключом к разнообразным цифровым сервисам. С ее помощью жители региона могут оплачивать товары и услуги, проезд в общественном транспорте, получать денежные переводы и выплаты, а также пользоваться скидками, бонусами и специальными предложениями от популярных торговых сетей - партнеров проекта.',

  polls: {
    surveyDescription:
      'Единая социальная карта является полноценной банковской картой с дополнительными сервисами. Держатель ЕСК может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегда будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.',

    voteDescription:
      'Единая социальная карта является полноценной банковской картой с дополнительными сервисами. Держатель ЕСК может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегда будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.',

    noSurveysOnMainPage: 'Нет действующих опросов',
    noVotesOnMainPage: 'Нет действующих голосований',
    noActiveSurveys: 'Нет действующих опросов',
    noActiveVotes: 'Нет действующих голосований',
    noCompletedSurveys: 'Нет прошедших опросов',
    noCompletedVotes: 'Нет прошедших голосований',
  },

  esksoContacts: {
    supportPhone: '88006000670',
    website: 'https://eskso.ru',
    socialPhone: '88003008100',
  },

  ekartaContacts: {
    website: 'http://ekarta-ek.ru',
  },

  footer: {
    copyright: '© 2020-2023. Все права защищены. ООО «САПФИР-ЭКСПЕРТ», ИНН 6672303952, ОГРН 1096672016870',
    socials: {
      facebook: '',
      instagram: '',
      vk: 'https://vk.com/eskso',
      telegram: '',
      ok: 'https://ok.ru/group/57030094815385',
    },
    stores: {
      appGallery: 'https://appgallery.huawei.com/#/app/C104356703',
      appStore:
        'https://apps.apple.com/ru/app/%D0%B5%D0%B4%D0%B8%D0%BD%D0%B0%D1%8F-%D1%81%D0%BE%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%B0%D1%80%D1%82%D0%B0/id1551174476',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.eskso',
      ruStore: 'https://www.rustore.ru/catalog/app/com.eskso',
    },
    telephones: {
      hotlineText: 'Горячая линия',
      unionNumberText: 'Единый социальный телефон (по вопросам льгот)',
    },
  },

  docs: {
    politics: 'https://eskso.ru/holder/capabilities/privacypolicy',
    agreement: 'https://st.eskso.ru/uploads/a-/Sk/DoP7eueC-q9B5ifPbJks3sPpCyHR.pdf',
  },

  cardBlocking: {
    blockMessage:
      'Если у вас возникли подозрения на мошеннические действия в отношении вашей карты, вы можете заблокировать ее. И обратиться в отделения пункта выдачи для перевыпуска.',
    unblockMessage:
      'Перевыпустить карту можно в личном кабинете, в ближайшем центре выпуска или по телефону горячей линии',
  },

  news: {
    noNewsInSelectedPeriod: 'За выбранный период новостей не найдено',
  },
};
